import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faPen, faCopy, faArrowLeft, faArrowRight, faServer, faTable, faDatabase,
  faFolderOpen, faFolderPlus, faFolder, faSync, faSitemap, faPlus, faTrash, faCheck, faTerminal,
  faPlay, faUndo, faEraser, faFilter, faTimes, faEdit, faClone, faPenSquare,
  faDoorOpen, faSignInAlt, faDesktop, faAtlas, faWrench, faAddressBook, faSlidersH, faPuzzlePiece,
  faHotel, faUsers, faHandsHelping, faUserTie, faBuilding, faCircle, faCogs, faFileWord, faGamepad,
  faEnvelopeSquare, faEnvelopeOpen, faLowVision, faHome, faGlobeEurope,
  faTachometerAlt, faCalendarAlt, faTasks, faChartBar, faHdd, faQuestion, faImage, faBinoculars,
  faSearch, faBriefcase, faArchive, faTrashAlt, faBullseye, faCoins, faMoneyCheckAlt, faTools,
  faFileInvoiceDollar, faComments, faFileImport, faChartPie, faHistory, faExchangeAlt, faAngleLeft,
  faUniversity, faDollarSign, faEuroSign, faFileCode, faSnowman, faCaretDown, faVial,
  faSort, faSortAmountDown, faSortAmountDownAlt, faThList, faArrowsAlt, faPowerOff, faKeyboard,
  faBook, faEllipsisH, faMars, faVenus, faQuestionCircle, faExclamationCircle, faInfoCircle,
  faBug, faTractor, faLink, faCog, faBars, faRedoAlt, faAngleRight, faSuitcase,
  faPhone, faPhoneAlt, faInfo, faClipboardList, faLock, faEye, faBan, faUser,
  faSortAlphaDown, faSortAlphaDownAlt, faFolderMinus, faIdCard, faKey, faPlane, faGlobe,
  faGlobeAfrica, faHourglassStart, faExclamationTriangle,
  faCloud, faCloudDownloadAlt, faCloudUploadAlt, faRubleSign, faFileExport, faCalculator,
  faCashRegister, faAngleDoubleDown, faArrowAltCircleDown, faFireAlt, faChevronCircleRight,
  faCircleNotch, faFireExtinguisher, faList, faGlasses, faArrowsAltV, faCheckDouble,
  faArrowDown, faTrain,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCircle as farCircle, faCheckCircle as farCheckCircle,
  faSquare as farSquare, faCheckSquare as farCheckSquare,
  faWindowMinimize as farWindowMinimize
} from '@fortawesome/free-regular-svg-icons';


library.add([
  // regular
  farCircle, farCheckCircle, farSquare, farCheckSquare, farWindowMinimize,
  // solid
  faPen, faCopy, faArrowLeft, faArrowRight, faServer, faTable, faDatabase,
  faFolderOpen, faFolderPlus, faFolder, faSync, faSitemap, faPlus, faTrash, faCheck, faTerminal,
  faPlay, faUndo, faEraser, faFilter, faTimes, faEdit, faClone, faPenSquare,
  faDoorOpen, faSignInAlt, faDesktop, faAtlas, faWrench, faAddressBook, faSlidersH, faPuzzlePiece,
  faHotel, faUsers, faHandsHelping, faUserTie, faBuilding, faCircle, faCogs, faFileWord, faGamepad,
  faEnvelopeSquare, faEnvelopeOpen, faLowVision, faHome, faGlobeEurope,
  faTachometerAlt, faCalendarAlt, faTasks, faChartBar, faHdd, faQuestion, faImage, faBinoculars,
  faSearch, faBriefcase, faArchive, faTrashAlt, faBullseye, faCoins, faMoneyCheckAlt, faTools,
  faFileInvoiceDollar, faComments, faFileImport, faChartPie, faHistory, faExchangeAlt, faAngleLeft,
  faUniversity, faDollarSign, faEuroSign, faFileCode, faSnowman, faCaretDown, faVial,
  faSort, faSortAmountDown, faSortAmountDownAlt, faThList, faArrowsAlt, faPowerOff, faKeyboard,
  faBook, faEllipsisH, faMars, faVenus, faQuestionCircle, faExclamationCircle, faInfoCircle,
  faBug, faTractor, faLink, faCog, faBars, faRedoAlt, faAngleRight, faSuitcase,
  faPhone, faPhoneAlt, faInfo, faClipboardList, faLock, faEye, faBan, faUser,
  faSortAlphaDown, faSortAlphaDownAlt, faFolderMinus, faIdCard, faKey, faPlane, faGlobe,
  faGlobeAfrica, faHourglassStart, faExclamationTriangle,
  faCloud, faCloudDownloadAlt, faCloudUploadAlt, faRubleSign, faFileExport, faCalculator,
  faCashRegister, faAngleDoubleDown, faArrowAltCircleDown, faFireAlt, faChevronCircleRight,
  faCircleNotch, faFireExtinguisher, faList, faGlasses, faArrowsAltV, faCheckDouble,
  faArrowDown, faTrain,
]);

export default FontAwesomeIcon;
